export default __webpack_public_path__ + "static/media/bus.8d58d4d8.png";